'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");
var ChangeLogEntry$PvpcontrollerWeb = require("./ChangeLogEntry.js");
var EditModeService$PvpcontrollerWeb = require("../services/EditModeService.js");

function EditModeChangeLogEntry(Props) {
  var session = Props.session;
  var changes = Props.changes;
  var alt = Props.alt;
  var change = Props.change;
  var simplified = Props.simplified;
  var onChangeRemoved = Props.onChangeRemoved;
  var onChangeRemovedFail = Props.onChangeRemovedFail;
  var match = React.useState(function () {
        return /* Normal */0;
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          switch (state) {
            case /* Normal */0 :
                return ;
            case /* DoPublishChange */1 :
                return EditModeService$PvpcontrollerWeb.publishEditModeChange(session, changes, change, (function (result) {
                              if (result.TAG === /* Ok */0) {
                                var match = result._0.status;
                                if (match !== 200) {
                                  return Curry._1(onChangeRemovedFail, undefined);
                                } else {
                                  return Curry._1(onChangeRemoved, undefined);
                                }
                              }
                              Curry._1(onChangeRemovedFail, undefined);
                              return Debugging$PvpcontrollerWeb.messageWithData("EditModeChangeLogEntry-PvpcontrollerWeb:publishEditModeChange Could not publish change.", {
                                          tags: (function (prim) {
                                              return {};
                                            }),
                                          extra: result._0
                                        });
                            }));
            case /* DoRollbackChange */2 :
                return EditModeService$PvpcontrollerWeb.rollbackEditModeChange(session, changes, change, (function (result) {
                              if (result.TAG === /* Ok */0) {
                                var match = result._0.status;
                                if (match !== 200) {
                                  return Curry._1(onChangeRemovedFail, undefined);
                                } else {
                                  return Curry._1(onChangeRemoved, undefined);
                                }
                              }
                              Curry._1(onChangeRemovedFail, undefined);
                              return Debugging$PvpcontrollerWeb.messageWithData("EditModeChangeLogEntry-PvpcontrollerWeb:rollbackEditModeChange Could not publish change.", {
                                          tags: (function (prim) {
                                              return {};
                                            }),
                                          extra: result._0
                                        });
                            }));
            
          }
        }), [state]);
  var tmp;
  switch (state) {
    case /* Normal */0 :
        tmp = React.createElement(React.Fragment, undefined, React.createElement("td", {
                  title: "Rollback this change",
                  onClick: (function (param) {
                      return Curry._1(setState, (function (previousState) {
                                    if (previousState !== 0) {
                                      return previousState;
                                    } else {
                                      return /* DoRollbackChange */2;
                                    }
                                  }));
                    })
                }, React.createElement("i", {
                      className: "fas fa-undo"
                    })), React.createElement("td", {
                  title: "Publish this change",
                  onClick: (function (param) {
                      return Curry._1(setState, (function (previousState) {
                                    if (previousState !== 0) {
                                      return previousState;
                                    } else {
                                      return /* DoPublishChange */1;
                                    }
                                  }));
                    })
                }, React.createElement("i", {
                      className: "fas fa-upload"
                    })));
        break;
    case /* DoPublishChange */1 :
        tmp = React.createElement(React.Fragment, undefined, React.createElement("td", undefined), React.createElement("td", undefined, React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps({
                          height: "8px",
                          minWidth: "8px",
                          width: "8px"
                        }, undefined, undefined, undefined, undefined, undefined, undefined, undefined))));
        break;
    case /* DoRollbackChange */2 :
        tmp = React.createElement(React.Fragment, undefined, React.createElement("td", undefined, React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps({
                          height: "8px",
                          minWidth: "8px",
                          width: "8px"
                        }, undefined, undefined, undefined, undefined, undefined, undefined, undefined))), React.createElement("td", undefined));
        break;
    
  }
  return React.createElement(ChangeLogEntry$PvpcontrollerWeb.make, ChangeLogEntry$PvpcontrollerWeb.makeProps(alt, change, simplified, Caml_option.some(tmp), undefined, undefined));
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8) {
  var tmp = {
    session: prim0,
    changes: prim1,
    alt: prim2,
    change: prim3,
    simplified: prim4,
    onChangeRemoved: prim5,
    onChangeRemovedFail: prim6
  };
  if (prim7 !== undefined) {
    tmp.key = prim7;
  }
  return tmp;
}

var make = EditModeChangeLogEntry;

exports.makeProps = makeProps;
exports.make = make;
/* react Not a pure module */
